import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Glyphicon, Button } from 'reaxl';
import PhoneNumber from '../PhoneNumber/index.js';

/**
 *   The PhoneNumberCallAction component will display a phone number
 *   If isCallable (Click To Call), it displays phone number as a hyperlink
 *
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function PhoneNumberCallAction(_ref) {
  let {
    className,
    extension,
    isButton = false,
    isCallable = false,
    onCall = () => {},
    phoneNumber,
    showIcon = false,
    isSnapshot = false,
    ...rest
  } = _ref;
  const phoneGlyph = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "phone",
    className: clsx(isButton ? undefined : 'margin-right-2 align-self-center', {
      'text-size-500 margin-right-3 link-unstyled': isSnapshot
    }),
    "aria-hidden": !isButton
  });
  const formatPhoneNumber = /*#__PURE__*/_jsxs(_Fragment, {
    children: [showIcon && phoneGlyph, /*#__PURE__*/_jsx(PhoneNumber, {
      className: className,
      phoneNumber: phoneNumber,
      extension: extension,
      ...rest
    })]
  });
  if (isCallable) {
    const props = {
      'data-cmp': 'ownerPhoneNumber',
      href: 'tel:' + phoneNumber,
      rel: 'nofollow',
      onClick: onCall,
      role: 'button'
    };
    if (isButton) {
      props.className = 'display-inline-block';
    } else {
      props.className = 'link-undecorated display-flex';
    }
    return /*#__PURE__*/React.createElement(isButton ? Button : 'a', props, isButton ? phoneGlyph : formatPhoneNumber);
  }
  return formatPhoneNumber;
}
export default PhoneNumberCallAction;